// ─── State ───────────────────────────────────────────────────────
let csActiveVariantId = null;
let csHasSizes = false;

// ─── Build the size <option> list for a product from its variants JSON ───
function csPopulateSizes(sizeSelect, variantsJson, sizeOptionPosition) {
  const variants = JSON.parse(variantsJson);
  const optionKey = 'option' + sizeOptionPosition;
  const seen = new Set();

  sizeSelect.innerHTML = '<option value="" selected disabled>Select a size</option>';

  variants.forEach(function (variant) {
    const size = variant[optionKey];
    if (!size || seen.has(size)) return;
    seen.add(size);

    const option = document.createElement('option');
    option.value = variant.id;
    option.textContent = size;
    sizeSelect.appendChild(option);
  });
}

// ─── Open Modal ──────────────────────────────────────────────────
function csOpenModal(btn) {
  const variantId = btn.dataset.variantId;
  const productTitle = btn.dataset.productTitle;
  csHasSizes = btn.dataset.hasSizes === 'true';

  const backdrop = document.getElementById('cs-modal-backdrop');
  const titleEl = document.getElementById('cs-modal-title');
  const formEl = document.getElementById('cs-modal-form');
  const successEl = document.getElementById('cs-modal-success');
  const emailInput = document.getElementById('cs-email-input');
  const sizeWrap = document.getElementById('cs-size-wrap');
  const sizeSelect = document.getElementById('cs-size-select');
  const submitBtn = document.querySelector('#cs-waitlist-form .cs-modal__submit');

  titleEl.textContent = productTitle;
  csActiveVariantId = variantId;

  if (csHasSizes) {
    const variantsScript = btn.closest('.cs-overlay__inner').querySelector('.cs-variants-json');
    csPopulateSizes(sizeSelect, variantsScript.textContent, btn.dataset.sizeOptionPosition);
    sizeSelect.required = true;
    sizeWrap.style.display = 'block';
  } else {
    sizeSelect.required = false;
    sizeWrap.style.display = 'none';
  }

  // Reset to form state
  formEl.style.display = 'block';
  successEl.style.display = 'none';
  emailInput.value = '';
  sizeSelect.value = '';
  submitBtn.textContent = 'NOTIFY ME';
  submitBtn.disabled = false;

  backdrop.classList.add('is-open');
  document.body.style.overflow = 'hidden';

  setTimeout(function () {
    (csHasSizes ? sizeSelect : emailInput).focus();
  }, 260);
}

// ─── Close Modal ─────────────────────────────────────────────────
function csCloseModal() {
  document.getElementById('cs-modal-backdrop').classList.remove('is-open');
  document.body.style.overflow = '';
}

// ─── Init ────────────────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', function () {
  const backdrop = document.getElementById('cs-modal-backdrop');
  const waitlistForm = document.getElementById('cs-waitlist-form');
  const sizeSelect = document.getElementById('cs-size-select');

  if (!backdrop || !waitlistForm) return;

  // Clicking anywhere on a coming-soon card's image opens the waitlist
  // modal directly instead of following the link to the PDP.
  document.addEventListener('click', function (e) {
    const card = e.target.closest('.cs-has-overlay');
    if (!card) return;
    const btn = card.querySelector('[data-cs-open]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    csOpenModal(btn);
  });

  // Selecting a size updates which variant the subscription is tied to
  sizeSelect.addEventListener('change', function () {
    if (this.value) csActiveVariantId = this.value;
  });

  // Close on backdrop click
  backdrop.addEventListener('click', function (e) {
    if (e.target === this) csCloseModal();
  });

  // Close on [data-cs-close] click
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cs-close]')) csCloseModal();
  });

  // Close on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && backdrop.classList.contains('is-open')) csCloseModal();
  });

  // Form submit — browser's native constraint validation (required email +
  // required size, when present) blocks this until both are valid.
  waitlistForm.addEventListener('submit', function (e) {
    e.preventDefault();

    const email = document.getElementById('cs-email-input').value.trim();
    const submitBtn = this.querySelector('.cs-modal__submit');

    if (!email || !csActiveVariantId) return;

    submitBtn.textContent = 'SUBMITTING...';
    submitBtn.disabled = true;

    new Klaviyo()
      .backInStockSubscribe({ email: email, variant: csActiveVariantId })
      .then(function (response) {
        if (response.success || response.status == 202) {
          document.getElementById('cs-modal-form').style.display = 'none';
          document.getElementById('cs-modal-success').style.display = 'block';
        } else {
          submitBtn.textContent = 'NOTIFY ME';
          submitBtn.disabled = false;
          alert('Something went wrong. Please try again.');
        }
      })
      .catch(function () {
        submitBtn.textContent = 'NOTIFY ME';
        submitBtn.disabled = false;
        alert('Something went wrong. Please try again.');
      });
  });
});
